import { render, staticRenderFns } from "./PreviewImages.vue?vue&type=template&id=5c327036&scoped=true&"
import script from "./PreviewImages.vue?vue&type=script&lang=js&"
export * from "./PreviewImages.vue?vue&type=script&lang=js&"
import style0 from "./PreviewImages.vue?vue&type=style&index=0&id=5c327036&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c327036",
  null
  
)

export default component.exports